import React from 'react';
import { Skeleton, useTheme } from '@mui/material';
import { PlusIconV2 } from '../../../assets/icons';
import {
  StyledCard,
  ImageContainer,
  SkeletonAddToBasketButton,
  ContentContainer,
  FlexRow,
  BrandLogoSkeleton,
  TextLineSkeleton,
} from '../style/ProductCardSkeletonV3.styles';

const META_LINE_WIDTHS = [0.85, 0.95, 0.9];

const ProductCardSkeletonV3: React.FC = () => {
  const theme = useTheme();

  return (
    <StyledCard>
      <ImageContainer>
        <Skeleton
          variant="rectangular"
          width="100%"
          height={theme.spacing(15)}
          sx={{ borderRadius: theme.spacing(1.5) }}
        />

        <SkeletonAddToBasketButton>
          <PlusIconV2 />
        </SkeletonAddToBasketButton>
      </ImageContainer>

      <ContentContainer>
        <FlexRow>
          <BrandLogoSkeleton variant="circular" width={theme.spacing(2)} height={theme.spacing(2)} />
          <TextLineSkeleton variant="rounded" width="55%" height={theme.spacing(1.25)} />
        </FlexRow>

        <TextLineSkeleton variant="rounded" width="45%" height={theme.spacing(2)} />

        <TextLineSkeleton variant="rounded" width="90%" height={theme.spacing(1.5)} />

        <FlexRow>
          <TextLineSkeleton variant="rounded" width="60%" height={theme.spacing(1.5)} />
          <TextLineSkeleton
            variant="rounded"
            width="28%"
            height={theme.spacing(1.5)}
            sx={{ borderRadius: theme.spacing(2) }}
          />
        </FlexRow>

        <FlexRow>
          <TextLineSkeleton variant="rounded" width="50%" height={theme.spacing(1.25)} />
          <TextLineSkeleton variant="rounded" width="30%" height={theme.spacing(1.25)} />
        </FlexRow>

        {META_LINE_WIDTHS.map((widthFraction, i) => (
          <TextLineSkeleton
            key={`meta-${i}`}
            variant="rounded"
            width={`${widthFraction * 100}%`}
            height={theme.spacing(1.25)}
          />
        ))}
      </ContentContainer>
    </StyledCard>
  );
};

export default ProductCardSkeletonV3;
